import { singleton } from 'tsyringe';
import { EventEmitter } from '../EventEmitter';

const TOKEN_TTL_MS = 24 * 60 * 60 * 1000;
const EXPIRY_BUFFER_MS = 5 * 60 * 1000;

@singleton()
export class QbAuthService {
    private accessToken: string | null = null;
    private expiresAt: number | null = null;
    public authStateChanged = new EventEmitter<boolean>(false);

    setToken(accessToken: string): void {
        this.accessToken = accessToken;
        this.expiresAt = Date.now() + TOKEN_TTL_MS;
        this.authStateChanged.emit(true);
    }

    getAccessToken(): string | null {
        if (this.isTokenExpired()) {
            return null;
        }
        return this.accessToken;
    }

    isTokenExpired(): boolean {
        if (!this.expiresAt) return true;
        return Date.now() >= this.expiresAt - EXPIRY_BUFFER_MS;
    }

    isAuthenticated(): boolean {
        return this.accessToken !== null && !this.isTokenExpired();
    }

    clearToken(): void {
        this.accessToken = null;
        this.expiresAt = null;
        this.authStateChanged.emit(false);
    }
}
